// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupOrderApprovalStatusTag_container__Yg95B","pending":"GroupOrderApprovalStatusTag_pending__6w4yU","active":"GroupOrderApprovalStatusTag_active__1YtRp"};